import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { ValueFormatterService } from '@wilson/ag-grid/service';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import { FilterKey, FilterModule } from '@wilson/filter';
import { PageFrameV2Component } from '@wilson/page-frame';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { QualificationV2ConfigModule } from '../../types';
import { SharedUserQualificationsComplementaryCertificateExportTriggerComponent } from './shared-user-qualifications-complementary-certificate-export-trigger/shared-user-qualifications-complementary-certificate-export-trigger.component';
import { SharedUserQualificationsExportTriggerComponent } from './shared-user-qualifications-export-trigger/shared-user-qualifications-export-trigger.component';
import { SharedUserQualificationsFilterDrawerComponent } from './shared-user-qualifications-filter-drawer/shared-user-qualifications-filter-drawer.component';
import { SharedUserQualificationsV2ListComponent } from './shared-user-qualifications-v2-list/shared-user-qualifications-v2-list.component';

interface FilterValues {
  partnerIds: string[];
  userIds: string[];
  status: string[];
  category: string[];
}

@Component({
  selector: 'wilson-shared-user-qualifications-v2-overview',
  imports: [
    CommonModule,
    FeatureFlagsModule,
    FilterModule,
    FontAwesomeModule,
    NzBadgeModule,
    NzButtonModule,
    NzDrawerModule,
    PageFrameV2Component,
    SharedUserQualificationsComplementaryCertificateExportTriggerComponent,
    SharedUserQualificationsExportTriggerComponent,
    SharedUserQualificationsFilterDrawerComponent,
    SharedUserQualificationsV2ListComponent,
    TranslatePipe,
  ],
  providers: [ValueFormatterService],
  templateUrl: './shared-user-qualifications-v2-overview.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './shared-user-qualifications-v2-overview.component.scss',
})
export class SharedUserQualificationsV2OverviewComponent implements OnInit {
  protected readonly qualificationV2Config =
    inject<QualificationV2ConfigModule>('QUALIFICATION_V2_CONFIG' as any);
  private route = inject(ActivatedRoute);

  searchFilter = new BehaviorSubject<string>('');
  userFilter = new BehaviorSubject<string[]>([]);
  partnerFilter = new BehaviorSubject<string[]>([]);
  statusFilter = new BehaviorSubject<string[]>([]);
  categoryFilter = new BehaviorSubject<string[]>([]);
  protected numberOfAppliedFilters$!: Observable<number>;
  protected filterKeys: FilterKey[] = [
    'userQualificationV2Status',
    'qualificationV2Category',
    'sharedUserQualificationV2Partner',
    'sharedUsers',
  ];
  faFilter = faFilter;
  isDrawerVisible = false;

  ngOnInit(): void {
    this.numberOfAppliedFilters$ = this.route.queryParams.pipe(
      map(
        (params) =>
          this.filterKeys.filter((key) => params[key] !== undefined).length,
      ),
    );
  }

  onSearchChange(event: string): void {
    this.searchFilter.next(event);
  }

  openDrawer(): void {
    this.isDrawerVisible = true;
  }

  onApplyFilters(filters: FilterValues): void {
    this.partnerFilter.next(filters.partnerIds);
    this.userFilter.next(filters.userIds);
    this.statusFilter.next(filters.status);
    this.categoryFilter.next(filters.category);
  }
}
